import { Box, IconButton, Flex, Icon, Text } from '@chakra-ui/react';
import { ChevronLeft } from 'react-iconly';
import { useSteps } from 'react-step-builder';
import { XIcon } from '@heroicons/react/outline';
import { useGetBluePrintQuery } from '@/store/query/blueprint';
import { Loader } from '@/design-system/loader';
import { OutreachForm } from '../outreach-form';
import { useCloneOutreachMutation } from '@/store/query/outreaches';
import { useHistory } from 'react-router-dom';
import { outreachFormDataToPayload } from '../utils/outreach-formdata-to-payload';
import { useMixpanel } from '@/hooks/use-mixpanel';
import { useShowToast } from '@/hooks/useShowToast';

const Header = ({ blueprint = {}, onClose = () => {} }) => {
  const { jump, prev } = useSteps();

  return (
    <Flex
      height="80px"
      borderBottom="1px"
      borderBottomColor="#E5E5E5"
      alignItems="center"
      px="24px"
    >
      <Flex flex="1" alignItems="center">
        <Box
          pos="relative"
          top="2px"
          cursor="pointer"
          onClick={() => {
            jump(1);
          }}
        >
          <Icon as={ChevronLeft} set="light" width="20px" height="20px" />
        </Box>
        <Text
          color="#0043CE"
          textDecor="underline"
          fontSize="14px"
          ml="4px"
          cursor="pointer"
          fontWeight="medium"
          onClick={() => {
            jump(1);
          }}
        >
          Create Outreach
        </Text>
        <Box ml="8px">/</Box>
        <Text
          ml="4px"
          color="#0043CE"
          textDecor="underline"
          fontSize="14px"
          cursor="pointer"
          fontWeight="medium"
          onClick={() => {
            prev();
          }}
        >
          {blueprint?.name}
        </Text>
        <Box ml="8px">/</Box>
        <Text ml="4px" fontWeight="medium">
          New Flow
        </Text>
      </Flex>
      <Box></Box>
      <Box>
        <IconButton
          variant="icon"
          ml="16px"
          onClick={onClose}
          icon={<Icon as={XIcon} width="16px" height="16px" />}
        />
      </Box>
    </Flex>
  );
};

export const CreateFromBluePrint = ({
  blueprint = {},
  onClose = () => {},
  quickCreate = false,
}) => {
  const { track } = useMixpanel();
  const [cloneOutreach, { isLoading }] = useCloneOutreachMutation();
  const history = useHistory();
  const toast = useShowToast();
  const { data, isLoading: isBlueprintLoading } = useGetBluePrintQuery({
    blueprintId: blueprint?.id,
  });

  const onSubmit = async (outreachFormData) => {
    const outreach = outreachFormDataToPayload(outreachFormData);
    try {
      const result = await cloneOutreach({
        params: outreach,
        outreachId: data?.outreach?.id,
      });

      if (result?.data?.id) {
        history.push(`/flows/${result?.data?.id}/steps`);
        toast({
          title: 'Flow created',
          position: 'bottom-left',
          status: 'success',
          isClosable: true,
        });
        window?.Appcues?.track('outreachCreated');
        track({
          event: 'outreach-created',
          prop: { source: 'blueprint' },
        });
        if (quickCreate) {
          onClose();
        }
        return;
      }
      toast({
        title: 'Flow creation failed',
        description: result?.error[0],
        position: 'bottom-left',
        status: 'error',
        isClosable: true,
      });
    } catch {}
  };

  return (
    <Flex flexDir="column" height="inherit">
      <Header blueprint={blueprint} onClose={onClose} />
      <Box flex="1" height="calc(100% - 80px)">
        {isBlueprintLoading ? (
          <Flex
            justifyContent="center"
            alignItems="center"
            height="calc(100% - 70px)"
          >
            <Loader />
          </Flex>
        ) : (
          <OutreachForm
            outreach={data?.outreach}
            onSubmit={onSubmit}
            isLoading={isLoading}
            type="clone"
          />
        )}
      </Box>
    </Flex>
  );
};
